import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = process.env.VUE_APP_API_URL;

export default {
  getKenyaProfile() {
    return axios.get(`${API_URL}settings/tax/kenya`, {
      headers: buildHeaders(),
    });
  },

  saveKenyaProfile(payload) {
    return axios.put(`${API_URL}settings/tax/kenya`, payload, {
      headers: buildHeaders(),
    });
  },

  getInvoiceCompliance(id) {
    return axios.get(`${API_URL}invoices/${id}/compliance`, {
      headers: buildHeaders(),
    });
  },

  getInvoiceComplianceLogs(id) {
    return axios.get(`${API_URL}invoices/${id}/compliance/logs`, {
      headers: buildHeaders(),
    });
  },

  submitEtims(id) {
    return axios.post(
      `${API_URL}invoices/${id}/submit-etims`,
      {},
      { headers: buildHeaders() }
    );
  },

  resubmitEtims(id) {
    return axios.post(
      `${API_URL}invoices/${id}/resubmit-etims`,
      {},
      { headers: buildHeaders() }
    );
  },
};
